import axios from "../../config/axiosConfig";
import { CREATE_RAW_MATERIAL_INWARD_CHALLAN, GET_RAW_MATERIAL_INWARD_CHALLANS, RAW_MATERIAL_INWARD_CHALLAN_REQUEST, UPDATE_RAW_MATERIAL_INWARD_CHALLAN, DELETE_RAW_MATERIAL_INWARD_CHALLAN, RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE } from "../types";

export const getRawMaterialInwardChallans = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };
      // if (!auth?.company?.Common_Company) {
      //   params = { ...params, companyId: auth.company?.id }
      // }
      return axios.get("/raw-material-inward-challan/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_RAW_MATERIAL_INWARD_CHALLANS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createRawMaterialInwardChallan = (production) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST });
      return axios.post("/raw-material-inward-challan/add", production,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_RAW_MATERIAL_INWARD_CHALLAN, payload: response.data });
        } else {
          dispatch({
            type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE,
            error: "Production create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateRawMaterialInwardChallan = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST });
      const { auth } = getState();
      return axios.put("/raw-material-inward-challan/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }
      }).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_RAW_MATERIAL_INWARD_CHALLAN,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE,
            error: "Production code update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteRawMaterialInwardChallan = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST });
      return axios.delete(`/raw-material-inward-challan/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_RAW_MATERIAL_INWARD_CHALLAN, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: RAW_MATERIAL_INWARD_CHALLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};